export { default } from "./CardHorizontal"
